import { gql } from '@apollo/client';

const MARATHON_EVENT_CONFIG_FRAGMENT = gql`
  fragment MarathonEventConfigFragment on MarathonEventConfig {
    id
    name
    startDate
    stopDate
    status
    category
    milestoneGroups {
      unlockDate
      stopDate
      milestones {
        numberOfGuesses
        type
        basicReward {
          type
          amount
          itemId
        }
        plusReward {
          type
          amount
          itemId
        }
      }
    }
    economy {
      startPrice
      revivePrice
      freeStartsPlus
      freeStartsBasic
      freeRevivesPlus
      freeRevivesBasic
    }
    filterUserIds
    filterSubscriptionTier
    filterUserMinCreationDate
    filterUserMaxCreationDate
    filterAppVersion
    filterUserLevel
  }
`;

export const GET_ALL_MARATHON_EVENTS = gql`
  query getAllMarathonEvents {
    liveOps {
      getAllMarathonEvents {
        id
    name
    startDate
    stopDate
    status
      }
    }
  }
`;

export const GET_MARATHON_EVENT = gql`
  query getMarathonEvent($id: ID!) {
    liveOps {
      getMarathonEvent(id: $id) {
        ...MarathonEventConfigFragment
      }
    }
  }
  ${MARATHON_EVENT_CONFIG_FRAGMENT}
`;

export const CREATE_MARATHON_EVENT = gql`
  mutation createMarathonEvent($input: CreateMarathonEventInput!) {
    createMarathonEvent(input: $input) {
      event {
        ...MarathonEventConfigFragment
      }
    }
  }
  ${MARATHON_EVENT_CONFIG_FRAGMENT}
`;

export const UPDATE_MARATHON_EVENT = gql`
  mutation updateMarathonEvent($input: UpdateMarathonEventInput!) {
    updateMarathonEvent(input: $input) {
      event {
        ...MarathonEventConfigFragment
      }
    }
  }
  ${MARATHON_EVENT_CONFIG_FRAGMENT}
`;

export const DELETE_MARATHON_EVENT = gql`
  mutation deleteMarathonEvent($id: ID!) {
    deleteMarathonEvent(id: $id)
  }
`;

const MARATHON_MILESTONE_TEMPLATE_FRAGMENT = gql`
  fragment MarathonMilestoneTemplateFragment on MarathonMilestoneTemplate {
    id
    name
    milestones {
      numberOfGuesses
      type
      basicReward {
        type
        amount
        itemId
      }
      plusReward {
        type
        amount
        itemId
      }
    }
  }
`;

export const GET_ALL_MARATHON_MILESTONE_TEMPLATE = gql`
  query getAllMarathonMilestoneConfigs {
    liveOps {
      getAllMarathonMilestoneConfigs {
        ...MarathonMilestoneTemplateFragment
      }
    }
  }
  ${MARATHON_MILESTONE_TEMPLATE_FRAGMENT}
`;

export const CREATE_MARATHON_MILESTONE_TEMPLATE = gql`
  mutation createMMilestonesTemplate($input: CreateMMTemplateInput!) {
    createMMilestonesTemplate(input: $input) {
      template {
        ...MarathonMilestoneTemplateFragment
      }
    }
  }
  ${MARATHON_MILESTONE_TEMPLATE_FRAGMENT}
`;

export const UPDATE_MARATHON_MILESTONE_TEMPLATE = gql`
  mutation updateMMilestonesTemplate($input: UpdateMMTemplateInput!) {
    updateMMilestonesTemplate(input: $input) {
      template {
        ...MarathonMilestoneTemplateFragment
      }
    }
  }
  ${MARATHON_MILESTONE_TEMPLATE_FRAGMENT}
`;

export const DELETE_MARATHON_MILESTONE_TEMPLATE = gql`
  mutation deleteMMilestonesTemplate($id: ID!) {
    deleteMMilestonesTemplate(id: $id)
  }
`;

export const GET_ALL_MARATHON_CATEGORIES = gql`
  query getAllCategoriesForMarathon {
    liveOps {
      getAllCategoriesForMarathon {
        id
        name
        contentPacks
        songs
      }
    }
  }
`;